<template>
  <div class="container">
    <!-- <mt-header title="用户注册">
      <router-link to slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)">返回</mt-button>
      </router-link>
    </mt-header>-->
    <div class="title">
      <span>名医智</span>|
      <span>注册</span>
    </div>
    <div class="form">
      <mt-field
        class="inputTxt"
        placeholder="请输入手机号"
        type="number"
        v-model="user.mobile"
        :state="usermobileStatus"
        @blur.native.capture="checkUsername"
      ></mt-field>
      <mt-field
        class="inputTxt"
        placeholder="请输入密码"
        type="password"
        v-model="user.password"
        :state="passwordStatus"
        @blur.native.capture="checkUserPwd"
      ></mt-field>
      <mt-field
        class="inputTxt"
        placeholder="请再输一次"
        type="password"
        v-model="password"
        :state="password2Status"
        @blur.native.capture="checkUserPwd2"
      ></mt-field>
      <div class="captchaBox">
        <mt-field
          placeholder="请输入验证码"
          type="tel"
          v-model="captcha"
          @blur.native.capture="regCaptcha"
        ></mt-field>
        <mt-button
          type="primary"
          :disabled="send"
          class="getcaptcha"
          @click="getCaptcha"
          >{{ send ? '验证码已发送' : '请获取验证码' }}</mt-button
        >
      </div>
      <!-- <mt-field label="身份选择：" class="inputStyle" disabled>
        <input type="radio" id="doctor" :value="2" v-model="user.userType" />医生
        <input type="radio" id="normal" :value="1" v-model="user.userType" />患者
      </mt-field>-->
    </div>
    <p class="deal">
      <input
        type="checkbox"
        v-model="check"
        class="checkbox"
        @click="checkon"
      />我已阅读并接受
      <a>《使用协议》</a>
    </p>
    <div class="btnBox">
      <div class="getBtn">
        <mt-button
          type="primary"
          class="btn"
          :disabled="disable"
          size="large"
          @click="register"
          >注册</mt-button
        >
      </div>
    </div>

    <div class="context">
      <router-link to="/login" class="login">已有账号，去登录</router-link>
      <p>
        遇到问题，请
        <a>关注微信公众号</a>留言
      </p>
      <p>&copy; 2000-2020 DYY 版权所有</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: '',
      usermobileStatus: '',
      password2Status: '',
      passwordStatus: '',
      user: {
        mobile: '',
        password: ''
        // userType: '2'
      },
      send: false,
      captcha: '',
      check: true,
      disable: false,
      captchaType: false
    }
  },
  mounted() {
    this.noShare()
  },
  methods: {
    // 表单验证
    // 验证手机号
    checkUsername() {
      var usernameReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!usernameReg.test(this.user.mobile)) {
        this.$toast('手机号格式错误！')
        this.usermobileStatus = 'error'
        return this
      } else {
        this.usermobileStatus = 'success'
      }
      this.$http({
        url: '/live/liveUsers/getByMobile/' + this.user.mobile,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$toast('该用户已存在，请登录')
          this.usermobileStatus = 'error'
          console.log(data)
        } else {
          this.usermobileStatus = 'success'
        }
      })
    },
    // 验证密码
    checkUserPwd() {
      var passwordReg = /^[0-9A-Za-z]{6,}$/
      if (!passwordReg.test(this.user.password)) {
        this.passwordStatus = 'error'
        this.$toast('密码至少为6位的数字、字母的组合')
        return this
      } else {
        this.passwordStatus = 'success'
      }
    },
    // 验证二次密码
    checkUserPwd2() {
      if (this.user.password !== this.password) {
        this.password2Status = 'error'
        return this
      } else {
        this.password2Status = 'success'
      }
    },
    regCaptcha() {
      this.$http({
        url: `/live/liveUsers/check/${this.user.mobile}/${this.captcha}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.captchaType = true
        } else {
          this.$messagebox.alert('验证码错误')
          this.captcha = ''
          this.captchaType = false
        }
      })
    },
    getCaptcha() {
      if (this.usermobileStatus === 'success') {
        this.$http({
          url: `/live/liveUsers/send/${this.user.mobile}`,
          method: 'get'
        }).then(({ data }) => {
          this.send = true
          this.$messagebox.alert('验证码已发送')
          setTimeout(() => {
            this.send = false
          }, 60000)
        })
      } else {
        this.$toast('手机号格式错误！')
      }
    },
    // 用户注册
    register() {
      if (this.captcha === '') {
        this.$messagebox.alert('验证码不能为空')
        return this
      }
      if (!this.captchaType) {
        this.$messagebox.alert('验证码错误')
        return this
      }
      if (
        this.usermobileStatus === 'success' &&
        this.passwordStatus === 'success' &&
        this.password2Status === 'success' &&
        this.captchaType
      ) {
        this.$http({
          url: '/live/liveUsers/save',
          method: 'post',
          data: this.user
        }).then(({ data }) => {
          if (data && data.code === 0) {
            // window.localStorage.setItem('userType', this.user.userType)
            this.$messagebox
              .confirm('注册成功,是否立即登录？', '提示信息')
              .then(action => {
                // this.$router.push('/login', () => {})
                const routeData = this.$router.resolve({
                  path: '/login'
                  //         query: { catId: catId }
                })
                window.open(routeData.href, '_blank')
              })
              .catch(() => {
                location.href = '/'
              })
          } else {
            this.user = {}
            this.$messagebox.alert('用户已经存在', '提示信息')
          }
        })
      } else {
        this.$messagebox.alert('注册信息不正确', '提示信息')
      }
    },
    checkon: function() {
      this.check = !this.check
      if (this.check) {
        this.disable = false
      } else {
        this.disable = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  padding: 2rem;
  font-size: 24px;
  color: #999;
  span {
    padding: 0 1rem;
    color: #333;
  }
  span:nth-child(2) {
    color: $theme-color;
    font-size: 18px;
  }
}
.getBtn {
  box-sizing: border-box;
  height: 55px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #fff;
}
.btn {
  // padding: 0 20px;
  width: 100%;
  height: 100%;
  font-size: $font-title;
}
.inputStyle /deep/ .mint-field-core {
  flex: 0;
  padding: 0;
  width: 0;
}
.container {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
  .form {
    border-top: 3rem solid #eee;
    padding: 0 1rem;
  }
  .inputTxt {
    padding: 0;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
  }
  .captchaBox {
    position: relative;
    .getcaptcha {
      position: absolute;
      top: 2px;
      right: 2px;
    }
  }
  .deal {
    text-align: center;
    margin: 2.4rem 0;
    .checkbox {
      position: relative;
      top: 2px;
    }
    a {
      color: $theme-color;
    }
  }
  /deep/ .mint-field-core {
    font-size: 1.4rem;
  }
  .btnBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .context {
    text-align: center;
    p {
      margin: 0.4rem 0;
    }
    .login {
      display: block;
      color: $theme-color;
      margin: 2rem 0rem 5rem;
    }
  }
}
</style>
